import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-audit-log',
    templateUrl: './audit-log.component.html',
    styleUrls: ['./audit-log.component.css'],
    standalone: false
})
export class AuditLogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
